import React from "react"
import { BaseVisualizationConfigureModal } from "../../../Modals/BaseVisualizationConfigureModal"
import { persystEEGAtom } from "../../../../Atoms/PersystWindow"
import { useEditWindow } from "../../../Modals/useEditWindow"
import { PersystEEGWindowJSON, PersystMontageDefinition } from "../../../../Types/PersystWindow"
import { WAVEFORM_WINDOW_TIME_PRESETS } from "../../../../../../../../Managers/VisualizationManager/Viewport/Components/XAxis"
import { MobergDropdown, MobergDropdownSize } from "../../../../../../../../Moberg"
import { ElementConfigureDiv } from "../../../../../../../../Constants/StyledComponents"
import { EEG_HIGH_FILTERS, EEG_LOW_FILTERS, EEG_NOTCH_FILTERS, PERSYST_EEG_SENSITIVITY } from "../../../../Types/EEG"
import { useRecoilValue } from "recoil"
import { currentPatientFileInfoAtom } from "../../../../Atoms/PatientFile"
import { isEqual } from "lodash"

type ConfigurePersystModalProps = {
	windowId: string
	layoutId: string
}

export const ConfigurePersystEEGModal = (props: ConfigurePersystModalProps) => {
	
	const atom = persystEEGAtom({ layoutId: props.layoutId, windowId: props.windowId })
	const { persystMontageDefinitions } = useRecoilValue(currentPatientFileInfoAtom)
	const { editedConfig, saveChanges, updateProperty } = useEditWindow<PersystEEGWindowJSON>({ recoilState: atom, windowId: props.windowId, layoutId: props.layoutId })
	
	return (
		<BaseVisualizationConfigureModal layoutId={props.layoutId} windowId={props.windowId} title={"Configure Persyst"} saveChanges={saveChanges}>
			<div style={{ height: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}>
				<div style={{ padding: "20px", width: "400px" }}>
				<ElementConfigureDiv>
					Initial Page Size

					<MobergDropdown
						selectedValue={editedConfig?.viewDuration}
						onChange={value => updateProperty("viewDuration", parseInt(value as string))}
						options={WAVEFORM_WINDOW_TIME_PRESETS
							.filter(preset => preset.label !== "Page Size")
							.map(preset => ({ label: preset.label, value: preset.time }))}
					/>
				</ElementConfigureDiv>
				<ElementConfigureDiv>
					Montage

				<MobergDropdown
					size={MobergDropdownSize.SMALL}
					selectedValue={editedConfig?.montage}
					onChange={montage => updateProperty("montage", montage)}
					options={persystMontageDefinitions.map(montage => ({ label: montage.name, value: montage }))}
					equals={(a: PersystMontageDefinition, b: PersystMontageDefinition) => isEqual(a, b)} />

				</ElementConfigureDiv>

				<ElementConfigureDiv>
					LFF

					<MobergDropdown
						selectedValue={editedConfig?.LFF}
						onChange={value => updateProperty("LFF", parseFloat(value as string))}
						options={Object.entries(EEG_LOW_FILTERS).map(([label, value]) => ({ label, value }))}
					/>
				</ElementConfigureDiv>

				<ElementConfigureDiv>
					HFF

					<MobergDropdown
						selectedValue={editedConfig?.HFF}
						onChange={value => updateProperty("HFF", parseFloat(value as string))}
						options={Object.entries(EEG_HIGH_FILTERS).map(([label, value]) => ({ label, value }))}
					/>
				</ElementConfigureDiv>

				<ElementConfigureDiv>
					Notch Filter Frequency

					<MobergDropdown
						selectedValue={editedConfig?.notch}
						onChange={value => updateProperty("notch", parseFloat(value as string))}
						options={Object.entries(EEG_NOTCH_FILTERS).map(([label, value]) => ({ label, value }))}
					/>
				</ElementConfigureDiv>

				<ElementConfigureDiv>
					Sensitivity
					<MobergDropdown
						selectedValue={editedConfig?.sensitivityMicroVolts}
						onChange={value => updateProperty("sensitivityMicroVolts", parseFloat(value as string))}
						options={Object.entries(PERSYST_EEG_SENSITIVITY).map(([label, value]) => ({ label, value }))}
					/>
				</ElementConfigureDiv>
				</div>
			</div>
		</BaseVisualizationConfigureModal>
	)
}
